import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gray-50 py-16 px-4" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 uppercase" data-id="element-116">
            🎯 EL PROBLEMA QUE NADIE LE ENSEÑA A LOS PADRES
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto" data-id="element-117"></div>
        </div>

        <div className="prose prose-lg mx-auto text-gray-700" data-id="element-118">
          <p className="font-bold text-xl" data-id="element-119">
            Invertiste años. Invertiste dinero. Invertiste ilusión.
          </p>
          <p data-id="element-120">Pero nadie te explicó cómo acompañarlo emocionalmente.</p>

          <p className="mt-6" data-id="element-121">Y empezás a ver señales:</p>
          <ul className="space-y-2 list-none pl-0" data-id="element-122">
            {['Se frustra tras errores', 'Pierde confianza', 'Se exige demasiado', 'Habla de dejarlo', 'Deja de disfrutar jugar'].map((item, i) => <li key={i} className="flex items-center gap-2 font-medium text-gray-800" data-id="element-123">
                <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-124" />
                {item}
              </li>)}
          </ul>

          <div className="my-8 bg-white p-8 rounded-xl shadow-md border border-gray-200 text-center" data-id="element-125">
            <p className="text-2xl font-black text-gray-900 uppercase mb-2" data-id="element-126">
              El fútbol juvenil no es solo físico.
            </p>
            <p className="text-3xl font-black text-red-600 uppercase" data-id="element-127">
              Es mental.
            </p>
          </div>

          <p className="text-center text-lg text-gray-700" data-id="element-128">
            Y cuando el acompañamiento falla, el{' '}
            <span className="text-green-600 font-bold" data-id="element-129">talento</span> se apaga.
          </p>
        </div>

        {/* El Verdadero Riesgo */}
        <div className="mt-16" data-id="element-130">
          <div className="text-center mb-8" data-id="element-131">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 uppercase" data-id="element-132">
              🧠 EL VERDADERO RIESGO
            </h3>
            <p className="text-gray-600 mt-2" data-id="element-133">
              Sin acompañamiento emocional adecuado:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-134">
            {['Baja la confianza progresivamente', 'Aumenta la presión interna', 'Se deteriora la relación padre–hijo', 'Aparece el desgaste deportivo', 'Crece el riesgo de abandono temprano'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg border border-red-100 shadow-sm" data-id="element-135">
                <XCircle className="w-6 h-6 text-red-600 flex-shrink-0" data-id="element-136" />
                <span className="font-medium text-gray-800" data-id="element-137">{item}</span>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-138">
            <p className="text-lg text-gray-700" data-id="element-139">
              La mayoría de los futbolistas no deja por falta de{' '}
              <span className="text-green-600 font-bold" data-id="element-140">talento</span>.
            </p>
            <p className="text-xl font-bold text-gray-900 mt-2" data-id="element-141">
              Deja por desgaste <span className="text-red-600" data-id="element-142">emocional</span>.
            </p>
          </div>
        </div>
      </div>
    </section>;
}